/* eslint-disable no-restricted-syntax */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { stopEvents, FreezeDocumentFeature } from './helpers';

export class UnFreezeDocumentCommand extends Command {
  editor: Editor;

  isEnabled: boolean;

  constructor(editor: Editor) {
    super(editor);
    this.editor = editor;
    this.isEnabled = false;
  }

  async execute(): Promise<void> {
    // Iterate through all the commands added to the editor.
    for (const command of this.editor.commands.commands()) {
      // Enable all commands.
      command.clearForceDisabled(FreezeDocumentFeature);
    }

    const viewDocument = this.editor.editing.view.document;

    // Remove listners on cutting and pasting. These actions happen during certain events.
    viewDocument.off('cut', stopEvents, { priority: 'highest' });
    viewDocument.off('clipboardInput', stopEvents, {
      priority: 'highest',
    });

    // Remove listners on doing any changes on Delete key.
    viewDocument.off('delete', stopEvents, { priority: 'highest' });
  }

  refresh(): void {
    this.isEnabled = true;
  }
}
